import {COUNTRY, Country} from '@domain/model/Site/Locale';
import {SITE, SiteDomain} from '@domain/model/Site/Site';

export const getSiteByCountry = (country: Country): SiteDomain =>
  country === COUNTRY.UK ? SITE.UK : country === COUNTRY.LU ? SITE.BE : country;
